import { canonicalStatus } from './workflowConstants';

export const DEFAULT_ORDER_LIST_FILTERS = {
  generalSearch: '',
  orderId: '',
  party: '',
  concept: '',
  category: '',
  beamColor: '',
  orderStatus: '',
};

/** Options for Order status dropdown — value '' = any */
export function getOrderWorkflowFilterOptions() {
  return [
    { value: '', label: 'All' },
    { value: 'DRAFT', label: 'Pending' },
    { value: 'APPROVED', label: 'Approved' },
    { value: 'PLACE_ORDER', label: 'Place order' },
    { value: 'IN_PRODUCTION', label: 'In production' },
    { value: 'PRODUCTION_DONE', label: 'Completed' },
    { value: 'BUTTA_CUTTING', label: 'Butta cutting' },
    { value: 'MILL_FINISH', label: 'Mill finish' },
    { value: 'BORDER_CUTTING', label: 'Border cutting' },
    { value: 'HANDWORK', label: 'Handwork' },
    { value: 'READY_FOR_DISPATCH', label: 'Ready for dispatch' },
    { value: 'IN_STOCK', label: 'In stock' },
    { value: 'DISPATCHED', label: 'Dispatched' },
    { value: 'DELIVERED', label: 'Delivered' },
    { value: 'CANCELLED', label: 'Cancelled' },
  ];
}

function includesCI(hay, needle) {
  if (!needle || !String(needle).trim()) return true;
  const n = String(needle).trim().toLowerCase();
  const h = String(hay ?? '').toLowerCase();
  return h.includes(n);
}

/**
 * Client-side filter for order list (list API returns full OrderResponse rows).
 */
export function applyOrderListFilters(orders, filters) {
  const f = { ...DEFAULT_ORDER_LIST_FILTERS, ...filters };
  return (orders || []).filter((o) => {
    const c = canonicalStatus(o.workflowStatus);

    if (f.orderStatus && f.orderStatus !== '' && c !== f.orderStatus) return false;

    if (f.orderId && String(f.orderId).trim()) {
      const q = String(f.orderId).trim().toLowerCase();
      const code = String(o.orderCode || '').toLowerCase();
      const idStr = String(o.id ?? '').toLowerCase();
      if (!code.includes(q) && !idStr.includes(q)) {
        const digits = q.replace(/\D/g, '');
        if (!digits || !String(o.id ?? '').includes(digits)) return false;
      }
    }

    if (!includesCI(o.partyName, f.party)) return false;
    if (!includesCI(o.designConceptName, f.concept)) return false;
    if (f.category && String(f.category).trim()) {
      if (
        !includesCI(o.designCategoryName, f.category) &&
        !includesCI(o.designSubCategoryName, f.category)
      ) {
        return false;
      }
    }
    if (!includesCI(o.beamColor, f.beamColor)) return false;

    const gs = String(f.generalSearch || '').trim().toLowerCase();
    if (gs) {
      const parts = [
        o.remark,
        o.designSampleNo,
        o.designSubCategoryName,
        o.designConceptName,
        o.partyName,
        o.partyMobile,
        o.brokerName,
        ...(o.lineItems || []).map((l) => [l.unit, l.takaNo, l.status].filter(Boolean).join(' ')),
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      if (!parts.includes(gs)) return false;
    }

    return true;
  });
}

export function countActiveOrderFilters(f) {
  let n = 0;
  if (String(f.generalSearch || '').trim()) n += 1;
  if (String(f.orderId || '').trim()) n += 1;
  if (String(f.party || '').trim()) n += 1;
  if (String(f.concept || '').trim()) n += 1;
  if (String(f.category || '').trim()) n += 1;
  if (String(f.beamColor || '').trim()) n += 1;
  if (f.orderStatus && f.orderStatus !== '') n += 1;
  return n;
}

/** Read `?status=` from the orders URL (dashboard deep-links). */
export function readOrderStatusFromSearch(search) {
  const params = new URLSearchParams(search || '');
  return params.get('status') || '';
}

/** Build `/orders` path with optional workflow status filter. */
export function ordersPathWithStatus(statusKey) {
  const base = '/orders';
  if (!statusKey) return base;
  return `${base}?status=${encodeURIComponent(statusKey)}`;
}

/** Navigate target for opening a specific order (pass as `location.state`). */
export function ordersOpenOrderState(orderId) {
  return { openOrderId: orderId };
}
